<template>
  <!--新增、 编辑 -->
  <a-modal v-model="visible" :close-on-click-modal="false" title="覆盖率报告" style="padding: 0px; top: 50px" width="1200px" :footer="null" @cancel="closeDialog()">
    <div class="task-main-202305011">
      <a-spin :spinning="loading" size="large" class="ant-spin-container">
        <iframe v-if="visible" ref="frameRef" title="cover-report-iframe" class="cover-report-iframe-main" :src="frameSrc" @load="loadFrame" />
      </a-spin>
    </div>
  </a-modal>
</template>
<script>
// 如果您没有在main.js文件中使用Vue.use(RelationGraph); 就需要使用下面这一行代码来引入relation-graph
import { ref } from 'vue';

export default {
  props: {
    url: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      loading: true,
      visible: false,
      frameSrc: ''
    };
  },
  methods: {
    open(url) {
      this.frameSrc = url;
      this.visible = true;
    },
    //     unref(value) {
    //     // 如果 value 是 ref 对象，则返回其 value 属性；否则直接返回 value。
    //     return value && value.value !== undefined ? value.value : value;
    // },
    closeDialog() {
      this.visible = false;
    },
    loadFrame() {
      this.loading = false;
      //   const iframe = this.unref(this.frameRef);
      //   if (!iframe) {
      //     return;
      //   }
      //   const _obj = iframe.contentWindow || iframe.contentDocument;
      //   const doc = _obj.document;
      //   doc.body.style.backgroundColor = '#F0F2F5';
    }
  }
};
</script>

<style lang="less">
.task-main-202305011 {
  height: calc(~'100vh - 50px');
  padding: 15px;
  .ant-spin-nested-loading {
    height: 100%;
  }
}
.cover-report-iframe-main {
  width: 100%;
  height: 100%;
  border: none;
}
.ant-spin-container {
  height: 100%;
}
</style>
